/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import { Button, Input, Popover, Select, Checkbox } from '@client/components';
import type { TDialogControls } from '@client/components/Dialog/Manager';
import useContext from '@/client/context';
import { Forbidden, UpgradeRequired } from '@common/errors';
import useForm from '@client/components/Form';

// App
import { Company2 } from '@models/types';
import PlansTable from './Plans';
import HeadhuntersSupport from '@/client/components/headhunter/help/support';

/*----------------------------------
- TYPES
----------------------------------*/

export type TProps = TDialogControls & {
    error?: UpgradeRequired
}

/*----------------------------------
- COMPONENT
----------------------------------*/
export default ({ close, error }: TProps) => {

    /*----------------------------------
    - INIT
    ----------------------------------*/

    const { api, toast, modal, user } = useContext();

    /*----------------------------------
    - ACTIONS
    ----------------------------------*/

    const [plans, setPlans] = React.useState(null);
    React.useEffect(() => {
        api.get('/user/plans').then(setPlans)
    }, []);

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    return (
        <div class="card col bg grey" style={{
            width: '100vw',
            height: '100vh',
        }}>

            <Button class="close" size="s" 
                icon="times" shape="pill" onClick={() => close(false)} />

            {plans === null ? (
                <div class="row-1 col al-center">
                    <i src="spin" />
                </div>
            ) : (
                <div class="row-1 col pdt-3">
                    <div class="col al-center">
                        <PlansTable plans={plans} context={error} />
                    </div>
                    <HeadhuntersSupport />
                </div>
            )}

        </div>
    )
}